import { Select,Form } from 'antd'
import React, { useEffect, useState } from 'react'
import { useGwGoodsTypeListQuery } from '../../store/ReactWebSiteApi';

function WebGoodsTypeSelect(props) {
    const [list,setList] = useState();
        const {data,isSuccess} = useGwGoodsTypeListQuery({eowgt_e_id:localStorage.getItem('e_id')})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){                
                const newArr = data.Result.map((item) => {
                    const {eowgt_id,eowgt_name }=item;
                    return item = {value:eowgt_id,label:eowgt_name }
                })
                setList(newArr)
            }
        }
    },[data,isSuccess])
    return (
        <>
            <Form.Item 
                label={props.label} 
                wrapperCol={props.wrapperCol} 
                required={props.required}
                name={props.name}
            >
                <Select 
                    options={list} 
                    onChange={(_,f) => {
                        console.log(f);
                        props.onChange(f.value,f.label,)
                    }}
                    defaultValue={props.defaultId}
                    placeholder={props.defaultId}
                    style={props.style}
                />
            </Form.Item>
        </>
    )
}

export default WebGoodsTypeSelect